import { token } from '@terra/ui-styled-system';
import {
  GRAPH_NODE_COLOR,
  type GraphNodeType,
} from '../external-network/constants';
import {
  AI_APPLICATION_EDGE_COLOR,
  AI_ATTACK_PATH_MARKS,
} from './finding-attack-path-ai-marks';

const PRODUCT_ENTITY_COLOR: Record<string, string> = {
  FINDING: token('colors.fg.entity.finding'),
  WEAKNESS: token('colors.fg.entity.signal'),
  ENDPOINT: token('colors.fg.entity.assets'),
  WEBPAGE: token('colors.fg.entity.assets'),
  CREDENTIAL: token('colors.fg.warning'),
  SURFACE: token('colors.fg.entity.entryPoint'),
};

export function findingAttackPathEntityColor(entityKind: string): string {
  if (entityKind === 'AI_APPLICATION') {
    return AI_APPLICATION_EDGE_COLOR;
  }

  const aiColor = AI_ATTACK_PATH_MARKS[entityKind]?.edge;

  if (aiColor) {
    return aiColor;
  }

  const productColor = PRODUCT_ENTITY_COLOR[entityKind];

  if (productColor) {
    return productColor;
  }

  const graphColor = GRAPH_NODE_COLOR[entityKind as GraphNodeType];

  if (graphColor) {
    return graphColor;
  }

  return token('colors.fg.entity.assets');
}
